import layout from '@/layout'

export default {
  path: '/advance_fund',
  component: layout,
  redirect: '/advance_fund/team/index',
  name: 'advance_fund_team_index',
  meta: {
    title: 'advance_fund',
    icon: 'el-icon-document'
  },
  children: [
    {
      path: '/advance_fund/team/index',
      name: 'advance_fund_team_index',
      component: () => import('@/views/team_advance_fund/index'),
      meta: {
        title: 'advance_fund_team_index',
        icon: 'el-icon-document'
      }
    }
  ]
}
